<script>
import HeaderBox from '@/components/HeaderBox.vue'
import { mapState } from 'vuex'

export default {
    name: 'VariableSection',
    components: { HeaderBox },
    computed: {
        ...mapState('debug', ['cardActive']),
        variables () {
            return this.cardActive ? this.cardActive.metadata : []
        }
    }
}
</script>

<template>
<div class="d-flex flex-column" style="gap: 10px">
  <HeaderBox>{{$t('variables') | capitalize}}:</HeaderBox>
    <el-table border :data="variables" show-overflow-tooltip>
        <el-table-column
            prop="key"
            :label="$t('variable') | capitalize">
        </el-table-column>
        <el-table-column
            prop="new_value"
            :label="$t('currentValue') | capitalize">
        </el-table-column>
        <el-table-column
            prop="old_value"
            :label="$t('previousValue') | capitalize">
        </el-table-column>
    </el-table>
</div>
</template>

<style scoped lang="scss">
table {
  border-collapse: collapse;

  td {
    padding: 4px 8px;
    border-bottom: 1px solid #D6D6D6;
  }
}

.table-header {
  background-color: #EDEDED;

  th {
    border-bottom: 1px solid #d6d6d6;
    padding: 4px 8px;
  }
}
</style>
